export default function tabsScrollTo() {
  const tabs = document.querySelector(".catalog__model-filters");
  const active = tabs.querySelector(".catalog__label--active");
  console.log(active.nextElementSibling);

  if (active && active.nextElementSibling) {
    const targetElement = active.nextElementSibling;

    // Вычисляем позицию элемента относительно контейнера
    const targetPositionLeft = targetElement.offsetLeft;
    const targetPositionTop = targetElement.offsetTop;

    // Выполняем скролл
    tabs.scrollTo({
      left: targetPositionLeft,
      top: targetPositionTop,
    });
  }
}
